module.exports = require('./dist/');